import { Coachmark } from 'components/coachmark';
import { t } from 'state/intl/translations';

type CloserRestaurantCoachmarkProps = {
  onDismiss: () => void;
  /** Human-readable distance to the closer restaurant (e.g. "3.5 miles"), from
   * `useCloserRestaurantCoachmark`. Interpolated into the body copy. */
  distanceText: string;
};

/**
 * Checkout's closer-restaurant coachmark: the shared `Coachmark` bubble plus this
 * feature's copy and testIDs. Presentation and positioning live in the shared
 * component; eligibility + distance calculation live in `use-closer-restaurant-coachmark`.
 */
export const CloserRestaurantCoachmark = ({
  onDismiss,
  distanceText,
}: CloserRestaurantCoachmarkProps) => (
  <Coachmark
    title={t('closerRestaurantCoachmarkTitle')}
    body={t('closerRestaurantCoachmarkBody', { distance: distanceText })}
    onDismiss={onDismiss}
    testID="closer-restaurant-coachmark"
  />
);
